import React from "react";
import { Popover } from "antd"; // or wherever Popover is from
import ExpandIcon from "../../assets/images/ExpandIcon.svg";
import { TabLabel } from "./TabViewStyled";
import PropTypes from "prop-types";

const CollapseButton = ({ setShowSideBar }) => {
  return (
    <Popover placement="bottomLeft" content={"Expand Folder Panel"}>
      <TabLabel
        tabactive="true"
        collapsebtn="true"
        onClick={() => {
          localStorage.setItem("sidebar", "true");
          setShowSideBar(true);
        }}
      >
        <button
          onClick={() => setShowSideBar(false)}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
          aria-label="Collapse sidebar"
        >
          <img src={ExpandIcon} alt="Expand icon" />
        </button>
      </TabLabel>
    </Popover>
  );
};

CollapseButton.propTypes = {
  setShowSideBar: PropTypes.func.isRequired,
};

export default CollapseButton;
